import { Phone, MessageCircle, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import EnquiryForm from "./EnquiryForm";
import { SITE } from "../constants/site";

const waLink = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMsg)}`;

const ROWS = [
  { icon: Phone, label: "Call the launch desk", value: SITE.phoneDisplay, href: `tel:${SITE.phoneDisplay.replace(/\s/g, "")}`, testid: "contact-phone-link" },
  { icon: MessageCircle, label: "WhatsApp us", value: "Instant response, 24 hours", href: waLink, testid: "contact-whatsapp-link" },
  { icon: MapPin, label: "Site address", value: "Opp. Korum Mall, near Cadbury Junction, Thane West", href: null, testid: "contact-address" },
];

export default function Contact() {
  return (
    <section id="enquire" data-testid="contact-section" className="py-24 md:py-32 border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6 grid lg:grid-cols-2 gap-16">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.35em] text-primary mb-5">Private Preview</p>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-tight mb-8">
            Schedule your <span className="italic text-primary">site visit</span>
          </h2>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed max-w-md mb-12">
            Pre-launch inventory is limited. Register for the brochure, costing and a private walkthrough of the
            experience centre.
          </p>
          <div>
            {ROWS.map(({ icon: Icon, label, value, href, testid }) => (
              <div key={label} className="flex items-center gap-5 border-b border-border/60 py-5">
                <Icon size={18} className="text-primary shrink-0" strokeWidth={1.5} />
                <div>
                  <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">{label}</p>
                  {href ? (
                    <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={testid} className="text-sm hover:text-primary transition-colors">
                      {value}
                    </a>
                  ) : (
                    <p className="text-sm" data-testid={testid}>{value}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="border border-border bg-white p-8 md:p-12 shadow-[0_24px_70px_rgba(18,32,49,0.10)]">
            <p className="font-display text-2xl md:text-3xl mb-8">Pre-register for best benefits</p>
            <EnquiryForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
